import axios from "axios";
import { API_URL } from "../../constants";

export const UpdateMreadCount = async (aid,ApiStatus) => {
    ApiStatus({ isLoader: true, isError: false, data: null });
    const token = sessionStorage.getItem('LOGIN_TOKEN');
    
    try {
        let res = await axios.get(API_URL + "follow/message_read/"+aid, {
            headers: {
                'Authorization': "Bearer " + token,
            }
        });
        ApiStatus({ isLoader: false, isError: false, data: res.data });
    } catch (err) {
        console.log(err.response);
        ApiStatus({ isLoader: false, isError: true, data: null });
    }

}